import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/bayandina.jpeg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonBayandina = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Баяндина Гульмира Дуйсенбаевна</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Doctor PhD, ассоциированный профессор (доцент) по специальности «Экономика» КОКСОН МОН РК
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=56658697700'}>
                            <MyText><LinkOutlined /> Scopus (h=1)</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0001-9436-0522'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>УО «Алматы Менеджмент Университет» (AlmaU), ассоциированный профессор Института предпринимательства и инноваций. Стаж по профилю — 26 лет.</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Специалист</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Подготовка и актуализация учебно-методических материалов для семинаров и тренингов по эффективному использованию трансграничных водных ресурсов;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Проведение семинаров и тренингов с применением современных ИТ в сельскохозяйственной отрасли Жамбылского региона;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка концепции и научной программы секции международной конференции;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Организация международной конференции по тематике трансграничных водных ресурсов.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Методологическое обеспечение проекта, организация и проведение мероприятий. Опыт в экономике водопользования и организации научных мероприятий.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR24993128 «ИАС трансграничных водных ресурсов» (2024-2026), специалист.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Публикации:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Баяндин, Баяндина, Нефтисов, Куатбеков. Современное состояние водных ресурсов в Республике Казахстан. Сб. трудов конф. к 100-летию Е.А. Букетова, 2025.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    2. Баяндин, Баяндина, Дюсеналин, Нефтисов. Трансграничное водное сотрудничество: необходимость и значимость. Вестник КУЭФМТ, №3(60), 2025.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    3. Баяндин, Бекмурзаева, Баяндина, Нефтисов, Дюсеналин. Водосберегающие технологии в сельском хозяйстве: методология и экономические аспекты. Вестник Торайгыров университета, №1, 2026.
                </MyText>
            </Flex>
        </Flex>
    );
};
